module.exports = __webpack_public_path__ + "static/media/external-link.9a42ab4b.svg";